<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}个{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
          <!-- <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">
            批量删除
          </el-button> -->
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span class="reset" v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" border v-loading="loading" :data="tableData" :max-height="tableHeight"
        style="width: 100%" @selection-change="handleSelectionChange" stripe
        :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <!-- <el-table-column type="selection" fixed align="center" width="55"></el-table-column> -->
        <el-table-column prop="priceMonitorId" label="平台企业编码" width="180">
          <template slot-scope="scope">
            {{ scope.row.priceMonitorId?scope.row.priceMonitorId:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="priceMonitorCompanyName" label="平台企业名称" min-width="190">
          <template slot-scope="scope">
            {{ scope.row.priceMonitorCompanyName?scope.row.priceMonitorCompanyName:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="priceMonitorCompanyTypeName" label="平台企业类型" width="190">
          <template slot-scope="scope">
            {{ scope.row.priceMonitorCompanyTypeName?scope.row.priceMonitorCompanyTypeName:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="no" label="院内企业信息编码" min-width="180"></el-table-column>
        <el-table-column prop="name" label="院内企业名称" min-width="190"></el-table-column>
        <el-table-column prop="stateName" label="启用状态" width="80">
          <template slot-scope="scope">
            <span :class="{
              enable: scope.row.state == 1,
              forbidden: scope.row.state == 0,
            }">{{ scope.row.stateName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="priceMonitorCompareStateName" width="100" label="是否对照"
          show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.priceMonitorCompareStateName?scope.row.priceMonitorCompareStateName:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="compareTime" width="170" label="最近更新时间" show-overflow-tooltip>
          <template slot-scope="scope">{{
            scope.row.compareTime?
            parseTime(new Date(scope.row.compareTime)):'-'
            }}</template>
        </el-table-column>
        <el-table-column prop="compareUserNo" label="对照人员编码" width="110">
          <template slot-scope="scope">
            {{ scope.row.compareUserNo?scope.row.compareUserNo:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="compareUserName" label="对照人员" width="100">
          <template slot-scope="scope">
            {{ scope.row.compareUserName?scope.row.compareUserName:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="operation" fixed="right" width="130" label="操作">
          <template slot-scope="scope">
            <el-button v-if="tableAcl.indexOf('Compare') != -1" type="text" v-preventReClick
              @click="showCompareDialog(scope.row)" class="color-blue">对照</el-button>
            <el-button v-if="
              tableAcl.indexOf('CancelCompare') != -1 &&
              scope.row.priceMonitorCompareState == 1
            " type="text" v-preventReClick @click="cancelCompare(scope.row)"
              class="margin-left20 color-blue">取消对照</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>

    <el-dialog title="对照企业信息" :visible.sync="compareDialogVisible" width="60%">
      <el-form ref="companyQueryForm" :model="companyQueryForm" label-width="100px">
        <el-row>
          <el-col :span="8">
            <el-form-item prop="companyId" label="平台企业编码">
              <el-input v-model="companyQueryForm.companyId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="companyName" label="平台企业名称">
              <el-input v-model="companyQueryForm.companyName"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item prop="range" label="平台企业类型">
              <el-select v-model="companyQueryForm.companyType" placeholder="请选择平台企业类型" filterable clearable :filter-method="getCompanyList" style="width:100%">
                <el-option v-for="item in PriceMonitorCompanyTypeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <!-- </el-row>
        <el-row> -->
          <el-col :span="8">
            <!-- <el-form-item> -->
            <el-button type="primary" @click="getCompanyList">查 询</el-button>
            <el-button @click="companyQueryReset">重 置</el-button>
            <!-- </el-form-item> -->
          </el-col>
        </el-row>
      </el-form>

      <el-table ref="multipleTable" border row-key="id" :data="companys" :max-height="tableHeight"
        style="width: 100%; min-height: 436px; margin-top: 10px" @selection-change="conmpanySelectionChange" stripe
        :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" style="height: 300px">
            <img src="../../../../assets/noData.png" width="150" height="150" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="companyQueryReset">恢复默认</div>
          </div>
        </template>
        <el-table-column type="selection" :reserve-selection="true" fixed align="center" width="55"></el-table-column>
        <el-table-column prop="companyId" label="平台企业编码" show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyName" label="平台企业名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyTypeName" label="平台企业类型" show-overflow-tooltip></el-table-column>

        <el-table-column prop="lastUpdateTime" label="最近更新时间" show-overflow-tooltip>
          <template slot-scope="scope">{{
            parseTime(new Date(scope.row.lastUpdateTime))
            }}</template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background layout="prev, pager, next" :current-page="companyQueryForm.pageIndex"
          :total="companyTotal" @current-change="companyChangePage">
        </el-pagination>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :disabled="compareMultiple" @click="compare">确 定</el-button>
        <el-button @click="compareDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetSuppliers,
  GetCompanys,
  CompareCompanyAndSupplier,
  CancelSupplierCompare,
} from "@/api";
import {
  PriceMonitorCompanyTypeOptions,
  WhetherOptions,
  PriceMonitorCompareStateOptions,
} from "@/enum";
import GetDataMixin from "@/mixin/getData-mixin";
import GetSpdDataMixin from "@/mixin/getData-spd-mixin";
import BaseListMixin from "@/mixin/baseList-mixin.js";
import SelectFilter from "@/components/table-select-filter";

export default {
  components: {
    SelectFilter,
  },
  mixins: [GetDataMixin, GetSpdDataMixin, BaseListMixin],
  data() {
    return {
      GetDatasAction: GetSuppliers,

      PriceMonitorCompanyTypeOptions: PriceMonitorCompanyTypeOptions,
      WhetherOptions: WhetherOptions,
      PriceMonitorCompareStateOptions: PriceMonitorCompareStateOptions,

      filterOptions: [
        {
          name: "平台企业编码",
          type: "input",
          code: "priceMonitorCompanyId",
        },
        {
          name: "平台企业名称",
          type: "input",
          code: "priceMonitorCompanyName",
        },
        {
          name: "平台企业类型",
          type: "select",
          code: "priceMonitorCompanyType",
          data: PriceMonitorCompanyTypeOptions,
        },
        {
          name: "院内企业编码",
          type: "input",
          code: "no",
        },
        {
          name: "院内企业名称",
          type: "input",
          code: "keyWord",
        },
        {
          name: "启用状态",
          type: "select",
          code: "state",
          data: WhetherOptions,
        },
        {
          name: "对照状态",
          type: "select",
          code: "priceMonitorCompareState",
          data: PriceMonitorCompareStateOptions,
        },
      ],

      supplierId: "",
      compareDialogVisible: false,
      companyQueryForm: {
        pageSize: 10,
        pageIndex: 1,
        companyId: "",
        companyName: "",
        companyType: "",
      },
      companys: [],
      conmpanySelection: [],
      compareMultiple: true,
      companyTotal: 0,
    };
  },
  methods: {
    showCompareDialog(row) {
      this.compareDialogVisible = true;
      // this.compareMultiple = false
      this.supplierId = row.id;
      this.companyQueryReset();
    },
    compare() {
      var companyId = this.conmpanySelection[0].id;
      CompareCompanyAndSupplier({
        supplierId: this.supplierId,
        companyId: companyId,
      }).then((res) => {
        this.$my_message(`对照成功`, "success");
        this.compareDialogVisible = false;
        this.supplierId = "";
        this.getData();
      });
    },
    cancelCompare(row) {
      this.$confirm("提示", {
        title: "提示",
        type: "warning",
        message: "确定要取消这条供应商信息的对照吗？",
      })
        .then(() => {
          return CancelSupplierCompare({ supplierId: row.id });
        })
        .then((res) => {
          this.$my_message(`取消对照成功`, "success");
          this.getData();
        });
    },
    getCompanyList() {
      GetCompanys(this.companyQueryForm).then((res) => {
        this.companys = res.returnData.data;
        this.companyTotal = res.returnData.totalCount;
      });
    },
    companyQueryReset() {
      this.companyQueryForm = {
        pageSize: 10,
        pageIndex: 1,
        companyId: "",
        companyName: "",
        companyType: "",
        priceMonitorType: 0,
      };

      this.getCompanyList();
    },
    companyChangePage(val) {
      this.$set(this.companyQueryForm, "pageIndex", val);
      this.getCompanyList();
    },
    conmpanySelectionChange(selection) {
      this.conmpanySelection = selection;
      this.compareMultiple = !(selection.length == 1);
    },
  },
  created() { },
  mounted() { },
};
</script>

<style lang="scss" scoped></style>
